document.addEventListener("DOMContentLoaded", async () => {
  const quantityInput = document.querySelector(".quantity__input");
  const plusButton = document.querySelector(".plus_button");
  const minusButton = document.querySelector(".minus_button");
  const customPriceDisplay = document.querySelector(".custom-price");
  const productSKU = document.querySelector(".price-item__custom")?.getAttribute("data-product-sku");
  const addToCartButton = document.querySelector(".product-form__submit");

  if (!quantityInput || !productSKU || !addToCartButton) {
    console.error("Missing necessary elements: ", { quantityInput, productSKU, addToCartButton });
    return;
  }

  const encodedMin = quantityInput.getAttribute("data-encoded-min");
  const stdPk = encodedMin ? parseInt(atob(encodedMin)) || 1 : 1;
  let currentQuantity = parseInt(quantityInput.value) || stdPk;
  let pricingData = null;

  const fetchPricingData = async () => {
    try {
      const apiUrl = `${window.globalData.customPricingUrl}?skus=${productSKU}`;
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`API request failed with status ${response.status}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching pricing data:", error);
      customPriceDisplay.innerText = "Error fetching price data.";
      return null;
    }
  };

  fetchPricingData().then(data => {
    if (data) {
      pricingData = data;
      window.customPricingData = data;
      document.dispatchEvent(new CustomEvent("customPricingDataReady"));
      updateMOQ();
      updatePrice(currentQuantity);
    }
  });

  const findClosestPrice = (quantity) => {
    if (!pricingData) return null;

    const matchedProducts = pricingData
      .filter(item => String(item.sku).trim() === String(productSKU).trim())
      .sort((a, b) => a.qtyBreak - b.qtyBreak);

    if (!matchedProducts.length) return null;

    let applicablePrice = matchedProducts[0].priceBreak;
    for (let product of matchedProducts) {
      if (quantity >= product.qtyBreak) {
        applicablePrice = product.priceBreak;
      } else {
        break;
      }
    }

    return applicablePrice;
  };

  const updatePrice = (quantity) => {
    let fetchedOriginalPrice = parseFloat(window.globalData?.shopifyPrice || 0);
  
    if (!pricingData) {
      console.error("Pricing data not available.");
  
      if (isNaN(fetchedOriginalPrice)) {
        console.warn("Shopify Price not yet available, retrying...");
        setTimeout(() => updatePrice(quantity), 100);
        return;
      }
  
      if (fetchedOriginalPrice === 0) {
        customPriceDisplay.style.display = "none";
      } else {
        customPriceDisplay.style.display = "block"; 
        customPriceDisplay.innerText = `$${fetchedOriginalPrice}`;
      }
      return;
    }
  
    const applicablePrice = findClosestPrice(quantity);
  
    if (applicablePrice !== null) {
      customPriceDisplay.style.display = "block"; 
      customPriceDisplay.innerText = `$${applicablePrice}`;
    } else {
      if (fetchedOriginalPrice > 0) {
        customPriceDisplay.style.display = "block"; 
        customPriceDisplay.innerText = `$${fetchedOriginalPrice}`;
      } else {
        customPriceDisplay.style.display = "none";
      }
    }
  };

  const updateMOQ = () => {
    const moq = parseInt(quantityInput.getAttribute("data-min"), 10) || stdPk;
    quantityInput.min = moq;
    
    if (!quantityInput.value || parseInt(quantityInput.value) < moq) {
      quantityInput.value = moq;
      currentQuantity = moq;
    }

    updatePrice(currentQuantity);
  };

  let debounceTimeout;
  const debounceUpdateMOQ = () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(updateMOQ, 200);
  };

  quantityInput.addEventListener("input", debounceUpdateMOQ);

  const updateQuantity = (newQuantity) => {
    if (newQuantity < stdPk || (newQuantity - stdPk) % stdPk !== 0) {
      newQuantity = stdPk;
    }

    currentQuantity = newQuantity;
    quantityInput.value = currentQuantity;
    quantityInput.setAttribute('value', currentQuantity);
    updatePrice(currentQuantity);
  };

  quantityInput.addEventListener("change", (event) => {
    updateQuantity(parseInt(event.target.value));
  });

  plusButton?.addEventListener("click", () => {
    updateQuantity(currentQuantity + stdPk);
  });

  minusButton?.addEventListener("click", () => {
    if (currentQuantity > stdPk) {
      updateQuantity(currentQuantity - stdPk);
    }
  });

  addToCartButton.addEventListener("click", async (event) => {
    const moq = parseInt(quantityInput.getAttribute("data-min"), 10) || stdPk;
    const quantity = parseInt(quantityInput.value, 10);

    if (quantity < moq) {
      event.preventDefault();
      console.warn("Quantity is below MOQ!", { quantity, moq });
      addToCartButton.classList.add("shake", "error-border");
      setTimeout(() => {
        addToCartButton.classList.remove("shake", "error-border");
      }, 500);
    }
  });
});